var React = require('react');

function IconError (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M0 0h96v85H0z"})),React.createElement("clipPath",{"id":"b","key":1},React.createElement("use",{"xlinkHref":"#a","overflow":"visible"})),React.createElement("path",{"clipPath":"url(#b)","fill":"#bb0043","d":"M95.556 79.904L51.019 1.743C50.406.666 49.252 0 48 0s-2.406.666-3.02 1.743L.447 79.904a3.372 3.372 0 0 0 .027 3.402A3.475 3.475 0 0 0 3.465 85h89.072a3.48 3.48 0 0 0 2.99-1.693 3.386 3.386 0 0 0 .029-3.403M53.5 75h-11V65h11v10zm0-17.502h-11v-30h11v30z","key":2})]);
}

IconError.defaultProps = {"width":"96","height":"85","viewBox":"0 0 96 85"};

module.exports = IconError;

IconError.default = IconError;
